'use client';

import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { Stepper } from '@lichtblick/photon/molecules/stepper';
import { Textfield } from '@lichtblick/photon/molecules/textfield';
import { useTracker } from '@lichtblick/tracker';
import { type ChangeEventHandler, type FC, useCallback, useState } from 'react';
import type { B2bCalculatorGasType } from '../../../types/storyblok';
import styles from './calculator.module.scss';

export const B2bCalculatorGas: FC<B2bCalculatorGasType> = () => {
  const [gasUsage, setGasUsage] = useState<string>();
  const [gasMeters, setGasMeters] = useState(1);

  const { trackCustomEvent } = useTracker();

  const gasChangeHandler = useCallback<ChangeEventHandler<HTMLInputElement>>(({ currentTarget }) => {
    setGasUsage(currentTarget.value);
  }, []);

  return (
    <form
      action="/checkout-b2b/gewerbegas"
      className={styles.form}
      id="b2b-gas-calculator"
      method="GET"
      onSubmit={({ currentTarget }) => {
        if (currentTarget.checkValidity()) {
          trackCustomEvent({
            eventName: 'b2b_calculator_show_lead_form',
            customProps: {
              product: 'GewerbeGas',
              meterCount: gasMeters,
              consumption_calculator: `${gasUsage} kWh/Jahr`,
            },
          });
        }
      }}
    >
      <Headline className={styles.headline} renderAs="h2" size="s">
        GewerbeGas
      </Headline>
      <Stepper defaultValue={1} label="Anzahl Zähler" min={1} onChange={setGasMeters} name="zaehler" hideLabelSuffix />
      <Textfield
        label="Gasverbrauch"
        min={0}
        name="gas"
        onChange={gasChangeHandler}
        rightSlot={
          <Text className={styles.unit} size="s">
            kWh/Jahr
          </Text>
        }
        type="number"
        hideLabelSuffix
        value={gasUsage}
      />

      <BoxCTA as="button" type="submit">
        Unverbindlich anfragen
      </BoxCTA>
    </form>
  );
};
